import { render, staticRenderFns } from "./ChecklistRedirect.vue?vue&type=template&id=6032932a&"
import script from "./ChecklistRedirect.vue?vue&type=script&lang=js&"
export * from "./ChecklistRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports